<template>
    <div class="footer">
        <div class="copyright-box">
            <div style="padding: 0 20px;">Copyright©2022 广州亿码科技有限公司</div>
            <a href="http://beian.miit.gov.cn/" class="filing-box">
                <img src="~@/assets/images/public/gn.gif">粤ICP备09007261号-97
            </a>
            <span style="margin-left: 10px;">互联网药品信息服务资格证书 (证书编号:(粤) -经营性-2021-0169) </span>
        </div>
    </div>
</template>

<script>
import AppLink from "@/components/common/link";
const page = {
    props: {},
    components: { AppLink },
};
export default page;
</script>

<style lang="scss" scoped>
.footer {
    padding: 3rem 0 1rem 0;
    color: #888;
    width: 100%;
    margin: 0 auto;
}

.footer .link-box {
    margin-top: 30px;
}

.footer .link-box .line {
    margin-left: 10px;
    margin-right: 10px;
}

.footer .copyright-box {
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    justify-content: center;
}

.footer .copyright-box .filing-box {
    display: flex;
    align-items: center;
    color: #888;
}

</style>


// WEBPACK FOOTER //
// src/layout/app/components/footer/index.vue